module.exports = "/assets/7854f9efc6eaeff5ffb13539c2212b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NU.png
// module id = 1659
// module chunks = 0